import api from "app/lib/api";
import { BASE_URL } from "static/constants";

export const accountList = (isPatientModal) => {
  if (isPatientModal) {
    const response = api.get(`${BASE_URL}/accounts`);

    return response;
  }
};
